<template lang="pug">
.overlay-tutorial
  .loading(v-if="orienting" @beforexrselect="preventXrSelect($event)")
    h1 {{__('Calibrating...', 'rackbuilder') }}
    h3 {{__('Move your device slowly in a figure-eight pattern to help the sensors detect your room.', 'rackbuilder')}}
    spinner
  ar-tutorial(v-if="tutorial" :state="tutorial" @input="updateState($event)")
  .controls(@beforexrselect="preventXrSelect($event)")
    button.a11y(@click="tutorial = 'troubleshoot'")
      Icon.threed-icon(name="rackbuilder/troubleshoot" fill="#fcb040")
    .mobile-spacer
    button.a11y(@click="xr.toggleXR()")
      Icon.threed-icon(name="rackbuilder/back" fill="white")
    button.a11y(@click="togglePlace(!placing)" :class="{active: placing}")
      Icon.threed-icon(name="rackbuilder/ar" fill="white")
</template>
<script lang="ts" setup>
import { onMounted, ref, nextTick } from 'vue'
import { Rogue3DEngine } from '../../composables/RogueEngineComposable'
import arTutorial from './ar-tutorial.vue'
import { useRogue } from '@/js/services/Rogue'

const rogue = useRogue()

const props = defineProps<{
  xr: any,
  engine: Rogue3DEngine
}>()

const tutorial = ref('orient')

const orienting = ref(true)
const placing = ref(false)
const placed = ref(false)

function togglePlace(enablePlace: boolean) {
  // props.engine.inputManager.inputMode = enablePlace ? RogueManagerInputMode.Placing : RogueManagerInputMode.Idle
  if (!placed.value) {
    enablePlace = true
  }

  props.xr.allowPlacing(enablePlace)
  placing.value = !!props.xr.enablePlace
}

function updateState(newState:string) {
  // When closing the Orient overlay, if we are already done orienting then immediately show the Place tutorial
  if (tutorial.value === 'orient' && newState === '' && !orienting.value) {
    newState = 'place'
  }

  tutorial.value = newState

  if (tutorial.value === 'exit' && newState === '') {
    togglePlace(true)
  }
}

function preventXrSelect(e:Event) {
  e.preventDefault()
}

onMounted(() => {
  if (!props.xr) {
    rogue.log.warn('AR Overlay loaded but no engine property')
  }
  togglePlace(false)

  props.xr.events.on('xrReady', () => {
    nextTick(() => {
      rogue.track.track({ type: 'AR', step: 'WebXR', arAction: 'ready' })
      togglePlace(false)
      orienting.value = false
      tutorial.value = 'place'
    })
  })

  props.xr.events.on('sceneAnchored', () => {
    nextTick(() => {
      rogue.track.track({ type: 'AR', step: 'WebXR', arAction: 'place' })
      placed.value = true
      togglePlace(false)
    })
  })
})

</script>
<style lang="scss" scoped>
.controls {
  position: absolute;
  bottom: $space-l;
  right: $space-l;
  pointer-events: all;
  display: flex;
  left: $space-l;

  @include not-mobile(){
    left: auto;
    flex-direction: column-reverse;
  }

  .a11y {
    background-color: black;
    height: 48px;
    width: 48px;
    border-radius: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    outline: none;

    @include not-mobile(){
      height: 64px;
      width: 64px;
      border-radius: 32px;
      margin-bottom: $space-s;
    }

    @include mobile(){
      &:not(:last-child){
        margin-right: 24px;
      }
    }
  }

  .threed-icon {
    height: 24px;
    width: 24px;

    @include not-mobile(){
      height: 32px;
      width: 32px;
    }
  }
}

.mobile-spacer {
  flex-grow: 1;
  @include not-mobile {
    display: none;
  }
}

.overlay-tutorial {
  user-select: none;
}

.loading {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.4);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white;

  h1 {
    margin-bottom: 32px;
  }

  h3 {
    max-width: 350px;
    text-align: center;
  }
}
</style>
